import { fas } from "@fortawesome/free-solid-svg-icons"

export const getGstChecks = (selectedRowData, dataAutomationData, dataVariable) => {
    if (dataVariable === "GST") {
        if (dataAutomationData.GST === true) {
            if (!(selectedRowData.gstNo || selectedRowData.panNo)) {
                return true
            }
        }
    } else {
        return false
    }
}
export const getMcaChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "MCA" && dataAutomationData.MCA === true) {
        return true
    } else {
        return false
    }
}

export const getDinChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "DIN" && dataAutomationData.DIN === true) {
        return true
    } else {
        return false
    }
}

export const getPanChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "PAN" && dataAutomationData.PAN === true) {
        return true
    } else {
        return false
    }
}

export const getEPFChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "EPF" && dataAutomationData.EPF === true) {
        return true
    } else {
        return false
    }
}
//<input type="text" name={dataVariable} onChange={props.handleTextChange} placeholder="Enter GST Number" className="form-control mca-data" />

export const getLegalChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "LEGAL" && dataAutomationData.LEGAL === true) {
        return true
    } else {
        return false
    }
}

export const getBseNseChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "STOCK_EXCHANGE" && dataAutomationData.STOCK_EXCHANGE === true) {
        return true
    } else {
        return false
    }
}

export const getRatingsChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "RATINGS" && dataAutomationData.RATINGS === true) {
        return true
    } else {
        return false
    }
}

export const getInternationalChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "INTERNATIONAL" && dataAutomationData.INTERNATIONAL === true) {
        return true
    } else {
        return false
    }
}

export const getXBRLChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "XBRL" && dataAutomationData.XBRL === true) {
        return true
    } else {
        return false
    }
}

// Social Media
export const getSocialMediaChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "SOCIALMEDIA" && dataAutomationData.SOCIALMEDIA === true) {
        return true
    } else {
        return false
    }
}

export const getNewsCheck = (dataAutomationData, dataVariable) => {
    if (dataVariable === "NEWS" && dataAutomationData.NEWS === true) {
        return true
    } else {
        return false
    }
}

export const getLEIChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "LEI" && dataAutomationData.LEI === true) {
        return true
    } else {
        return false
    }
}

export const getIECChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "IEC" && dataAutomationData.IEC === true) {
        return true
    } else {
        return false
    }
}

export const getUdyamChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "UDYAM" && dataAutomationData.UDYAM === true) {
        return true
    } else {
        return false
    }
}

export const getUdyogChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "UDYOG" && dataAutomationData.UDYOG === true) {
        return true
    } else {
        return false
    }
}

export const getNicCodeSearchChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "NICCODE_SEARCH" && dataAutomationData.NICCODE_SEARCH === true) {
        return true
    } else {
        return false
    }
}

export const getGstAnalysisChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "GST_ANALYSIS" && dataAutomationData.GST_ANALYSIS === true) {
        return true
    } else {
        return false
    }
}

export const getBankStatementAnalysisChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "BANK_STATEMENT_ANALYSIS" && dataAutomationData.BANK_STATEMENT_ANALYSIS === true) {
        return true
    } else {
        return false
    }
}

export const getITRAnalysisChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "ITR_ANALYSIS" && dataAutomationData.ITR_ANALYSIS === true) {
        return true
    } else {
        return false
    }
}

export const getEmailChecks = (dataAutomationData, dataVariable) => {
    // return dataVariable === "EMAIL" && dataAutomationData.EMAIL === true; 
}

export const getRetailBureauAnalysisChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "RETAIL_BUREAU" && dataAutomationData.RETAIL_BUREAU === true) {
        return true
    } else {
        return false
    }
}

export const getZigramChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "AML_PEP" && dataAutomationData.AML_PEP === true) {
        return true
    } else {
        return false
    }
}

export const getAdditionalLegalChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "ADDITIONAL_LEGAL" && dataAutomationData.ADDITIONAL_LEGAL === true) {
        return true
    } else {
        return false
    }
}
export const getMasterDataSyncChecks = (dataAutomationData, dataVariable) => {
    
    const result = dataAutomationData && 
                   dataVariable === 'MCA_DATA_SYNC' && 
                   dataAutomationData[dataVariable] === true;
    
    return result;
};
export const getStatusCheck = (dataVariable, crawlerData) => {
    if(crawlerData.length > 0){
        for (let i = 0; i < crawlerData.length; i++) {
            if (crawlerData[i].crawlerName === dataVariable) {
                return crawlerData[i].crawlerStatus;
            }
        }    
    } else {
        return "";
    }
}

export const getFailureReason = (dataVariable, crawlerData) => {
    if(crawlerData.length > 0){
        for (let i = 0; i < crawlerData.length; i++) {
            if (crawlerData[i].crawlerName === dataVariable) {
                return crawlerData[i].failureReason;
            }
        }    
    } else {
        return "";
    }
}

export const getSubCrawler = (dataVariable, crawlerData) => {
    if (crawlerData?.length > 0) {
        for (let i = 0; i < crawlerData.length; i++) {
            if (crawlerData[i].crawlerName === dataVariable) {
                return crawlerData[i].subCrawler;
            }
        }
    }
    return [];
};
const PROCEED = "PROCEED";
const CLOSE = "CLOSE";
export const handleConfirmModalButton = (type) => {
    if (type === PROCEED) {
        console.log("procced");
    }else if(type=== CLOSE){
        console.log("camcel");
    }
    
}